import React from 'react';
import { Link } from 'react-router-dom';
import { LayoutDashboard, LogIn, UserPlus } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { COMPANY_BRAND_NAME, COMPANY_TAGLINE } from '../../support/brand';
import {
  COMPANY_HOME_URL,
  PANEL_LOGIN_URL,
  PANEL_LEAD_URL,
} from '../../support/publicUrls';
import BrandLogo from './BrandLogo';

function PublicHeader() {
  const { isAuthenticated } = useAuth();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 surface-header">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-forge-300/60 to-transparent" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <a
            href={isAuthenticated ? '/' : COMPANY_HOME_URL}
            className="flex items-center gap-3 group"
            aria-label={COMPANY_BRAND_NAME}
          >
            <BrandLogo />
            <div className="flex flex-col">
              <span className="text-lg font-bold text-content-primary tracking-tight">
                {COMPANY_BRAND_NAME}
              </span>
              <span className="text-[10px] text-forge-600 font-medium tracking-widest uppercase -mt-0.5">
                {COMPANY_TAGLINE}
              </span>
            </div>
          </a>

          <nav className="flex items-center gap-2 sm:gap-4">
            <a
              href="/agente-ia-whatsapp"
              className="hidden md:inline text-sm font-medium text-content-secondary hover:text-content-primary transition-colors"
            >
              Agente de IA para WhatsApp
            </a>
            <a
              href="/mentor-ia"
              className="hidden md:inline text-sm font-medium text-content-secondary hover:text-content-primary transition-colors"
            >
              Mentoria digital
            </a>
            <a
              href="/artigos"
              className="hidden sm:inline text-sm font-medium text-content-secondary hover:text-content-primary transition-colors"
            >
              Artigos e guias
            </a>
            <a
              href="/#features"
              className="hidden sm:inline text-sm font-medium text-content-secondary hover:text-content-primary transition-colors mr-1"
            >
              Recursos
            </a>
            {isAuthenticated ? (
              <Link to="/agents" className="btn-primary text-sm px-4 py-2">
                <LayoutDashboard className="h-4 w-4 shrink-0" aria-hidden />
                Painel
              </Link>
            ) : (
              <>
                <a href={PANEL_LOGIN_URL} className="btn-secondary text-sm px-4 py-2">
                  <LogIn className="h-4 w-4 shrink-0" aria-hidden />
                  Entrar
                </a>
                <a href={PANEL_LEAD_URL} className="btn-primary text-sm px-4 py-2">
                  <UserPlus className="h-4 w-4 shrink-0" aria-hidden />
                  Criar conta
                </a>
              </>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
}

export default PublicHeader;
